export const calculatePriceForCard = ({
  monthlyPrice,
  annualPrice,
  isAddonActive,
}) => {
  const monthlyTotal = isAddonActive ? +monthlyPrice + 40 : +monthlyPrice;
  const annualTotal = isAddonActive ? +annualPrice + 400 : +annualPrice;

  const effectiveMonthly = annualTotal / 12;
  const savingsPercent = Math.round(
    ((monthlyTotal * 12 - annualTotal) / (monthlyTotal * 12)) * 100
  );

  return {
    monthlyTotal,
    annualTotal,
    savings: {
      effectiveMonthly,
      savingsPercent,
    },
  };
};
